import React from 'react';
import MediaItem from './MediaItem';

function MediaLibrary({ media = [], value, accept, onPick }) {
    return (
        <div className="media-library">
            {media.map(file => (
                <MediaItem
                    key={file.id}
                    file={file}
                    isActive={value === file.id}
                    onPick={onPick}
                />
            ))}
            {media.length === 0 && accept && (
                <p className="help">
                    You have no media that matches the file types <strong>{accept}</strong>
                </p>
            )}
            {media.length === 0 && !accept && (
                <p className="help">
                    You have no media in your library yet. Upload something and they will show here.
                </p>
            )}
        </div>
    );
}

export default MediaLibrary;

